import { HttpInterceptorFn } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { AuthService } from '../_services/auth.service';
import { inject } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

export const tokenInterceptor: HttpInterceptorFn = (req, next) => {
	const authService = inject(AuthService);
	const translate = inject(TranslateService);
	const language = (authService.getLingua() ?? translate.getBrowserLang() ?? 'it').toUpperCase();

	const headers = req.headers
		.set('Content-Type', 'application/json')
		.set('Authorization', 'Basic ' + btoa(`${environment.apiUsername}:${environment.apiPassword}`));

	let body = req.body;
	if (req.method !== 'GET') {
		//se c'è già un body li mergio
		if (body && typeof body === 'object') {
			body = { ...body, language };
		} else {
			//altrimenti ne creo uno nuovo
			body = { language };
		}
	}

	req = req.clone({ headers, body });
	return next(req);
};
